/**
 * Generated runtime TestId mirror for frontend/src/pages/RestrictionRuleViolationsDashboard.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const RestrictionRuleViolationsDashboardTestIds = {
  colDeniedProfiles: "col-denied-profiles",
  colDetectedAt: "col-detected-at",
  colName: "col-name",
  colRuleName: "col-rule-name",
  violationsDashboard: "violations-dashboard",
  linkIdentity: (v_identity_id: string) => `link-identity-${v_identity_id}`,
  linkIdentityPrefix: () => "link-identity-" as TestIdPrefix,
  linkRule: (v_ruleId: string) => `link-rule-${v_ruleId}`,
  linkRulePrefix: () => "link-rule-" as TestIdPrefix
} as const;
